export default __webpack_public_path__ + "static/O0134-5afd8893758d12b13b95ddd9caefb42c.png";